module.exports = __webpack_public_path__ + "static/media/clock.f1a21248.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/img/clock.svg
// module id = 426
// module chunks = 0